'use client';

import { useState, useEffect } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import { getLocale, getMessages, type Locale } from './client';

export function LocaleProvider({ 
  children,
  initialMessages 
}: { 
  children: React.ReactNode;
  initialMessages: any;
}) {
  const [locale, setLocale] = useState<Locale>('en');
  const [messages, setMessages] = useState(initialMessages);

  useEffect(() => {
    // Load the correct locale and messages on mount
    const currentLocale = getLocale();
    setLocale(currentLocale);
    
    if (currentLocale !== 'en') {
      getMessages(currentLocale).then(msgs => {
        setMessages(msgs);
      });
    }
  }, []);

  return (
    <NextIntlClientProvider
      messages={messages}
      locale={locale}
      timeZone="UTC"
    >
      {children}
    </NextIntlClientProvider>
  );
}
